import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgTokensStack = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 16 16"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="#0C6A93" clipPath="url(#TokensStack_svg__a)">
            <path d="M5.48 12.982a.166.166 0 0 0 .16-.166v-1.56a.167.167 0 0 0-.174-.167q-.4.018-.8.018c-1.402.035-2.8-.168-4.133-.6a.166.166 0 0 0-.226.159V12.1c0 .498 1.951.898 4.359.898q.418 0 .815-.017M4.666 5.108a10 10 0 0 0 4.27-.725.17.17 0 0 0 .09-.147v-1.57a.167.167 0 0 0-.228-.155 12.4 12.4 0 0 1-4.133.6 12.4 12.4 0 0 1-4.134-.6.167.167 0 0 0-.224.156v1.57a.17.17 0 0 0 .088.146c1.353.552 2.812.8 4.271.725M4.666 2.442a10 10 0 0 0 4.27-.725.17.17 0 0 0 .09-.147v-.28c0-.497-1.952-.901-4.36-.901s-4.36.404-4.36.9v.282a.17.17 0 0 0 .09.146c1.352.552 2.81.8 4.27.725M4.666 10.44q.427 0 .815-.019a.167.167 0 0 0 .159-.167V9.233a1.6 1.6 0 0 1 .097-.59.17.17 0 0 0-.02-.158.17.17 0 0 0-.144-.067q-.454.024-.907.025a12.4 12.4 0 0 1-4.133-.6.167.167 0 0 0-.226.156v1.573a.17.17 0 0 0 .088.146 10 10 0 0 0 4.271.722M4.666 7.774a14 14 0 0 0 4.267-.725.17.17 0 0 0 .089-.147v-1.57a.167.167 0 0 0-.227-.155 12.4 12.4 0 0 1-4.134.6 12.4 12.4 0 0 1-4.133-.6.167.167 0 0 0-.221.156v1.572a.17.17 0 0 0 .088.147 10 10 0 0 0 4.271.722M7.2 10.455a.167.167 0 0 0-.227.155v1.572a.17.17 0 0 0 .088.147c1.354.553 2.812.8 4.272.725a10 10 0 0 0 4.271-.725.17.17 0 0 0 .089-.147V10.61a.166.166 0 0 0-.228-.155 12.4 12.4 0 0 1-4.133.6 12.4 12.4 0 0 1-4.132-.6M11.333 13.72c-1.401.036-2.8-.167-4.133-.6a.167.167 0 0 0-.227.156v1.435c0 .498 1.951.901 4.359.901s4.36-.4 4.36-.9v-1.435a.167.167 0 0 0-.228-.155 12.4 12.4 0 0 1-4.13.599M6.975 9.235v.28a.17.17 0 0 0 .088.148c1.353.551 2.811.799 4.27.724a10 10 0 0 0 4.272-.724.17.17 0 0 0 .088-.148v-.28c0-.497-1.951-.901-4.36-.901-2.407 0-4.358.404-4.358.9" />
        </g>
        <defs>
            <clipPath id="TokensStack_svg__a">
                <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
        </defs>
    </svg>
)
const ForwardRef = forwardRef(SvgTokensStack)
const Memo = memo(ForwardRef)
export default Memo
